
export const environment = {
  production: false,
  apiBaseUrl: 'https://beta.auctions.api.appunveil.com/api',
  socketUrl: 'wss://beta.auctions.api.appunveil.com',
  appName: 'AgriXe Auctions',
  mainSiteUrl: 'https://www.agrixe.com',
  companyName: 'AgriXe Innovations Pvt Ltd',
  cdnBaseUrl: 'https://d31eer8za315j9.cloudfront.net/',
  requireBankingDetails: false, // Set to false to temporarily disable banking details validation
};